import ProductTab from "./ProductTab";

function PkcsPhoto() {
  return (
    <div className="px-4 py-8 pb-28 mx-auto max-w-7xl">
      {/* Header */}
      <div className="flex flex-col items-center text-center">
        <h1 className="text-2xl font-bold text-gray-800">
          อัปโหลดรูปภาพ PK/CS
        </h1>
      </div>

      <div className="mt-6">
        <ProductTab />
      </div>
    </div>
  );
}

export default PkcsPhoto;
